import { Component, Input, SimpleChanges } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ChartModule } from 'primeng/chart';
import { ROLE_GROUP_CONSTANTS } from "../../../shared/constants/role.constants";
import { RoleService } from "../../../shared/constants/role.service";
import { NgxSkeletonLoaderModule } from 'ngx-skeleton-loader'; // ✅ import


@Component({
  selector: 'app-geography-chart-carousel',
  standalone: true,
  imports: [CommonModule, ChartModule, NgxSkeletonLoaderModule],
  templateUrl: './geography-chart-carousel.component.html',
  styleUrls: ['./geography-chart-carousel.component.scss']
})
export class GeographyChartCarouselComponent {
  ROLE_GROUP_CONSTANTS = ROLE_GROUP_CONSTANTS;
  role_id: any;
  @Input() chartsData: any[] = [];
  @Input() bucketurl!: string;
  @Input() currentIndex: number = 0;
  @Input() totalSlides: number = 0;

  @Input() prevSlide!: () => void;
  @Input() nextSlide!: () => void;
  @Input() loading: boolean = true;


  constructor(public roleService: RoleService) { }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['chartsData']) {
      if (changes['chartsData'].currentValue) {
        // this.loading = false;
      }
    }
  }

  ngOnInit(): void {
    if (sessionStorage.getItem('loginResponse')) {
      const loginResponse = JSON.parse(sessionStorage.getItem('loginResponse') || '{}');
      if (loginResponse && loginResponse.data) {
        this.role_id = loginResponse.data?.user?.role_id;
      }
    }
  }

}
